/* =============================================================================
   Furniselan — Collection Results & Native Search & Discovery Filters
   + Fast Delivery Pincode-Linked Filter
   + Price Range Double Slider
   + Mobile Slide-in Drawer
   + Back-navigation scroll & state restoration
   + FAST filtered loading: progressive page-by-page render + prefetch cache
   + FIX: random scroll-to-top (popstate reload, pageshow, pincode render)
   + FIX v2: removed late "scrollTo(0)" on init, time-based scroll restore,
             no full reload on JS error after DOM replace, scroll guard on append
   ============================================================================= */
(function () {
  'use strict';

  // Disable browser's native scroll restoration. We control it ourselves.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  var FS = window.FS || {}, qs = FS.qs || function (s, c) { return (c || document).querySelector(s); },
      qsa = FS.qsa || function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); },
      once = FS.once || function (el, key) { if (!el) return false; el._fsOnce = el._fsOnce || {}; if (el._fsOnce[key]) return false; el._fsOnce[key] = true; return true; },
      reduceMotion = FS.reduceMotion || false;

  /* --------------------------------------------------------------------------
     STATE (declared up-front so every function can use it)
  -------------------------------------------------------------------------- */
  var infiniteObserver = null;
  var isLoadingInfinite = false;
  var scrollCheckAttached = false;
  var FILTERED_PRODUCT_BATCH_SIZE = 9;  // itne matching products milte hi batch ruk jata hai
  var PARALLEL_PAGES = 6;               // filter active hone par ek saath kitne pages fetch start hon
  var PREFETCH_PAGES = 4;               // page load ke baad background me kitne pages cache karein
  var infiniteGen = 0;                  // purane (stale) fetch ignore karne ke liye
  var pageCache = {};                   // url -> Promise<html>  (in-flight + done dono cache)

  function curUrl() {
    return window.location.pathname + window.location.search;
  }

  /* --------------------------------------------------------------------------
     PINCODE & FAST DELIVERY HELPERS
  -------------------------------------------------------------------------- */
  function getSavedPincode() {
    try {
      return localStorage.getItem('fs-pincode') || '';
    } catch (_) {
      return '';
    }
  }

  // Zones JSON bada ho sakta hai — sirf tab parse karo jab raw string badle
  var _zonesRaw = null, _zonesParsed = [];
  function getMetaZones() {
    var modal = qs('[data-pin-modal]');
    if (!modal) return [];
    var raw = modal.dataset.metaobjectZones || '[]';
    if (raw !== _zonesRaw) {
      try { _zonesParsed = JSON.parse(raw); } catch (_) { _zonesParsed = []; }
      _zonesRaw = raw;
    }
    return _zonesParsed;
  }

  // Returns delivery status object for given 6-digit pin
  function checkPincodeStatus(pin) {
    if (!pin || pin.length !== 6) return null;
    var metaZones = getMetaZones();

    // 1. Check custom express zones first (e.g. BLR, MUM, DL-NCR)
    for (var i = 0; i < metaZones.length; i++) {
      var mz = metaZones[i];
      if (mz.handle !== 'ready-stock' && mz.handle !== 'made-to-order') {
        if (mz.zips && mz.zips.indexOf(pin) > -1) {
          return {
            type: 'express',
            label: mz.label,
            message: mz.message || 'Estimated Delivery Timeline 1 to 2 Days',
            isFast: true
          };
        }
      }
    }

    // 2. Check ready-stock
    for (var k = 0; k < metaZones.length; k++) {
      var mz2 = metaZones[k];
      if (mz2.handle === 'ready-stock' && mz2.zips && mz2.zips.indexOf(pin) > -1) {
        return {
          type: 'ready-stock',
          label: 'Ready Stock',
          message: mz2.message || 'Estimated Delivery Timeline 8 to 9 Days',
          isFast: false
        };
      }
    }

    // 3. Check made-to-order
    for (var m = 0; m < metaZones.length; m++) {
      var mz3 = metaZones[m];
      if (mz3.handle === 'made-to-order' && mz3.zips && mz3.zips.indexOf(pin) > -1) {
        return {
          type: 'made-to-order',
          label: 'Made to Order',
          message: mz3.message || 'Estimated Delivery Timeline 20 to 25 Days',
          isFast: false
        };
      }
    }

    return null;
  }

  /* --------------------------------------------------------------------------
     UPDATE PRODUCT CARDS DYNAMIC DELIVERY BADGE
     noFilter = true => sirf badges/dataset update karo, applyFastDeliveryFilter
     mat chalao (off-DOM batch processing ke liye).
  -------------------------------------------------------------------------- */
  function cleanDeliveryMessage(msg) {
    if (!msg) return '';
    return msg.replace(/[⚡\s]+/g, ' ').trim();
  }

  function updateCardDeliveryBadges(wrap, pin, noFilter) {
    var cards = qsa('.product-card', wrap || document);
    var metaZones = getMetaZones();

    // Find global ready-stock and made-to-order zones, plus all express zones
    var readyStockZone = null;
    var madeToOrderZone = null;
    var expressZones = [];

    for (var i = 0; i < metaZones.length; i++) {
      var mz = metaZones[i];
      if (mz.handle === 'ready-stock') {
        readyStockZone = mz;
      } else if (mz.handle === 'made-to-order') {
        madeToOrderZone = mz;
      } else {
        expressZones.push(mz);
      }
    }

    // Check which express zone contains user's pin (if any)
    var matchedExpressZone = null;
    if (pin && pin.length === 6) {
      for (var j = 0; j < expressZones.length; j++) {
        var ez = expressZones[j];
        if (ez.zips && ez.zips.indexOf(pin) > -1) {
          matchedExpressZone = ez;
          break;
        }
      }
    }

    cards.forEach(function (card) {
      var delTextEl = qs('[data-card-delivery-text]', card);
      if (!delTextEl) return;
      var deliveryEl = qs('[data-card-delivery]', card);
      if (deliveryEl) deliveryEl.hidden = !pin || pin.length !== 6;

      var staticMsg = cleanDeliveryMessage(card.dataset.deliveryMsg || '');
      var readyStock = card.dataset.readyStock !== 'false';
      var cardZoneHandle = (card.dataset.zoneHandle || '').toLowerCase().trim();
      var variantZipsStr = card.dataset.variantZips || '';
      var variantZips = variantZipsStr ? variantZipsStr.split(',').map(function (z) { return z.trim(); }) : [];

      var delIconEl = qs('[data-card-delivery-icon]', card);
      var isAvailable = card.dataset.available !== 'false';
      var priceEl = qs('.product-card__price', card);
      if (priceEl && priceEl.textContent.toLowerCase().indexOf('sold out') > -1) {
        isAvailable = false;
      }

      if (!pin || pin.length !== 6) {
        // Default text when no pincode entered yet
        if (staticMsg) {
          delTextEl.textContent = staticMsg;
        } else if (readyStock) {
          delTextEl.textContent = 'Estimated Delivery Timeline 8 to 9 Days';
        } else {
          delTextEl.textContent = 'Estimated Delivery Timeline 20 to 25 Days';
        }
        card.classList.remove('is-fast-delivery');
        card.classList.remove('is-unavailable-delivery');
        if (delIconEl) delIconEl.style.display = 'none';
        card.dataset.isExpressMatch = 'false';

        // Tag deliveryType when no pin
        if (staticMsg && (staticMsg.indexOf('20 to 25') > -1 || staticMsg.indexOf('20-25') > -1)) {
          card.dataset.deliveryType = 'mto';
        } else if (staticMsg && (staticMsg.indexOf('8 to 9') > -1 || staticMsg.indexOf('8-9') > -1)) {
          card.dataset.deliveryType = 'normal';
        } else if (!readyStock) {
          card.dataset.deliveryType = 'mto';
        } else {
          card.dataset.deliveryType = 'normal';
        }
        return;
      }

      /* Step a: Express match (Strictly 1 to 2 Days & In Stock) */
      var isExpress = false;
      var expressMsg = '';

      var isStaticNonExpress = staticMsg && (staticMsg.indexOf('8 to 9') > -1 || staticMsg.indexOf('8-9') > -1 || staticMsg.indexOf('20 to 25') > -1 || staticMsg.indexOf('20-25') > -1);
      var isStaticExpress = staticMsg && (staticMsg.indexOf('1 to 2') > -1 || staticMsg.indexOf('1-2') > -1 || staticMsg.toLowerCase().indexOf('express') > -1);

      if (isAvailable && !isStaticNonExpress && cardZoneHandle !== 'ready-stock' && cardZoneHandle !== 'made-to-order') {
        // Direct zip check on variant express zips
        if (variantZips.length > 0 && variantZips.indexOf(pin) > -1) {
          isExpress = true;
          expressMsg = isStaticExpress ? staticMsg : 'Estimated Delivery Timeline 1 to 2 Days';
        } else if (matchedExpressZone) {
          var ezHandle = (matchedExpressZone.handle || '').toLowerCase();
          if (cardZoneHandle && cardZoneHandle === ezHandle) {
            isExpress = true;
            expressMsg = isStaticExpress ? staticMsg : cleanDeliveryMessage(matchedExpressZone.message) || 'Estimated Delivery Timeline 1 to 2 Days';
          }
        }
      }

      if (isExpress) {
        var cleanMsg = cleanDeliveryMessage(expressMsg || 'Estimated Delivery Timeline 1 to 2 Days');
        if (cleanMsg.indexOf('8 to 9') > -1 || cleanMsg.indexOf('8-9') > -1 || cleanMsg.indexOf('20 to 25') > -1 || cleanMsg.indexOf('20-25') > -1) {
          isExpress = false;
        } else {
          delTextEl.textContent = cleanMsg;
          card.classList.add('is-fast-delivery');
          card.classList.remove('is-unavailable-delivery');
          if (delIconEl) delIconEl.style.display = 'inline-block';
          card.dataset.isExpressMatch = 'true';
          card.dataset.deliveryType = 'fast';
          return;
        }
      }

      /* Step b: Check global ready-stock / made-to-order zips */
      var globalObj = readyStock ? readyStockZone : madeToOrderZone;
      var globalZips = (globalObj && globalObj.zips) || [];
      var globalMsg = (globalObj && globalObj.message) || (readyStock ? 'Estimated Delivery Timeline 8 to 9 Days' : 'Estimated Delivery Timeline 20 to 25 Days');

      if (globalZips.length > 0 && globalZips.indexOf(pin) > -1) {
        delTextEl.textContent = cleanDeliveryMessage(globalMsg);
        card.classList.remove('is-fast-delivery');
        card.classList.remove('is-unavailable-delivery');
        if (delIconEl) delIconEl.style.display = 'none';
        card.dataset.isExpressMatch = 'false';
        var cleanedGlobal = cleanDeliveryMessage(globalMsg);
        if (cleanedGlobal.indexOf('20 to 25') > -1 || cleanedGlobal.indexOf('20-25') > -1 || !readyStock) {
          card.dataset.deliveryType = 'mto';
        } else {
          card.dataset.deliveryType = 'normal';
        }
        return;
      }

      /* Step c: Unserviceable Pincode Fallback (Matches PDP logic) */
      delTextEl.textContent = 'Delivery not available at this pincode';
      card.classList.remove('is-fast-delivery');
      card.classList.add('is-unavailable-delivery');
      if (delIconEl) delIconEl.style.display = 'none';
      card.dataset.isExpressMatch = 'false';
      card.dataset.deliveryType = 'unserviceable';
    });

    // If any delivery toggle is active, filter visible cards
    if (!noFilter) applyFastDeliveryFilter(wrap);
  }

  /* --------------------------------------------------------------------------
     DELIVERY CLIENT-SIDE FILTERING (Fast, Normal, Made to Order)
  -------------------------------------------------------------------------- */
  function getCardDeliveryType(card) {
    if (card.dataset.deliveryType) {
      return card.dataset.deliveryType;
    }
    if (card.classList.contains('is-fast-delivery') || card.dataset.isExpressMatch === 'true') {
      return 'fast';
    }
    var delText = (card.querySelector('[data-card-delivery-text]') || {}).textContent || '';
    if (delText.indexOf('1 to 2') > -1 || delText.indexOf('1-2') > -1 || delText.toLowerCase().indexOf('express') > -1) {
      return 'fast';
    }
    if (delText.toLowerCase().indexOf('not available') > -1) {
      return 'unserviceable';
    }
    if (delText.indexOf('20 to 25') > -1 || delText.indexOf('20-25') > -1 || card.dataset.readyStock === 'false') {
      return 'mto';
    }
    return 'normal';
  }

  function applyFastDeliveryFilter(wrap) {
    var fastToggle = qs('[data-delivery-toggle="fast"], [data-fast-delivery-toggle]', wrap || document);
    var normalToggle = qs('[data-delivery-toggle="normal"], [data-normal-delivery-toggle]', wrap || document);
    var mtoToggle = qs('[data-delivery-toggle="mto"], [data-mto-delivery-toggle]', wrap || document);

    var isFast = !!(fastToggle && fastToggle.checked);
    var isNormal = !!(normalToggle && normalToggle.checked);
    var isMto = !!(mtoToggle && mtoToggle.checked);

    // Sync visual is-checked class on container rows
    [
      { el: fastToggle },
      { el: normalToggle },
      { el: mtoToggle }
    ].forEach(function (item) {
      if (!item.el) return;
      var row = item.el.closest('.c-fast-delivery');
      if (row) {
        if (item.el.checked) {
          row.classList.add('is-checked');
        } else {
          row.classList.remove('is-checked');
        }
      }
    });

    var selectedTypes = [];
    if (isFast) selectedTypes.push('fast');
    if (isNormal) selectedTypes.push('normal');
    if (isMto) selectedTypes.push('mto');

    var anyActive = selectedTypes.length > 0;
    var cards = qsa('.product-card', wrap || document);
    var tcells = qsa('.tcellrow', wrap || document);
    var visibleCount = 0;

    cards.forEach(function (card) {
      var isDeliveryMatch = true;

      if (anyActive) {
        var dType = getCardDeliveryType(card);
        isDeliveryMatch = selectedTypes.indexOf(dType) > -1;

        // Express match also requires available and not sold out
        if (dType === 'fast') {
          var isAvail = card.dataset.available !== 'false';
          var priceEl = qs('.product-card__price', card);
          if (priceEl && priceEl.textContent.toLowerCase().indexOf('sold out') > -1) {
            isAvail = false;
          }
          if (!isAvail) isDeliveryMatch = false;
        }
      }

      if (isDeliveryMatch) {
        card.classList.remove('is-fast-hidden');
      } else {
        card.classList.add('is-fast-hidden');
      }

      if (!card.classList.contains('is-cat-hidden') && !card.classList.contains('is-fast-hidden')) {
        if (card.style.display !== '') card.style.display = '';
        visibleCount++;
      } else {
        if (card.style.display !== 'none') card.style.display = 'none';
      }
    });

    // Hide trust row when filtered by delivery so grid stays clean
    tcells.forEach(function (tr) {
      tr.style.display = anyActive ? 'none' : '';
    });

    // Infinite-scroll element (needed for count label + empty state logic)
    var infEl = qs('.infinity_scroll', wrap || document);
    var hasMorePages = !!(infEl && infEl.dataset.nextUrl && infEl.style.display !== 'none');

    // Update count display
    var countEl = qs('#fcount', wrap || document);
    if (countEl) {
      if (!countEl.dataset.originalCount || countEl.dataset.originalCount.indexOf('(') > -1) {
        var currentText = countEl.textContent.trim();
        if (currentText.indexOf('(') === -1 && currentText.indexOf('Finding') === -1) {
          countEl.dataset.originalCount = currentText;
        }
      }

      if (anyActive) {
        var labels = [];
        if (isFast) labels.push('Fast Delivery');
        if (isNormal) labels.push('Ready to ship');
        if (isMto) labels.push('Made to Order');
        var stillLoading = visibleCount === 0 && hasMorePages;
        countEl.textContent = stillLoading
          ? 'Finding designs (' + labels.join(' + ') + ')…'
          : visibleCount + ' designs (' + labels.join(' + ') + ')';
      } else {
        var orig = countEl.dataset.originalCount;
        if (orig && orig.indexOf('(') === -1) {
          countEl.textContent = orig;
        } else {
          countEl.textContent = visibleCount + ' designs';
        }
      }
    }

    // Empty state message when delivery filter is active but 0 products match
    var grid = qs('.product-grid', wrap || document);
    var emptyNotice = qs('[data-fast-empty-notice]', wrap || document);

    if (anyActive && visibleCount === 0) {
      if (hasMorePages) {
        // More products exist on subsequent pages — do not show empty notice yet!
        if (emptyNotice) {
          emptyNotice.style.display = 'none';
        }
        var gif = qs('.gif_image_inner', infEl);
        if (gif) gif.classList.remove('hidden');
        loadMoreProducts(wrap || document, infEl);
      } else {
        var currentPin = getSavedPincode();
        if (!emptyNotice && grid) {
          emptyNotice = document.createElement('div');
          emptyNotice.className = 'c-empty-fast-notice';
          emptyNotice.setAttribute('data-fast-empty-notice', 'true');
          grid.parentNode.insertBefore(emptyNotice, grid.nextSibling);
        }
        if (emptyNotice) {
          if (isFast && !isNormal && !isMto) {
            emptyNotice.innerHTML =
              '<div class="c-empty-fast-notice__inner">' +
                '<span class="c-empty-fast-notice__icon">⚡</span>' +
                '<h3 class="c-empty-fast-notice__title">Fast Delivery is not available for pincode ' + (currentPin ? '<strong>' + currentPin + '</strong>' : '') + '</h3>' +
                '<p class="c-empty-fast-notice__text">Currently, 1-2 Days Express Delivery is not serviceable at this location. You can view all designs with standard delivery.</p>' +
                '<button type="button" class="btn btn--primary" data-turn-off-fast style="cursor:pointer;">View All Products</button>' +
              '</div>';
          } else {
            emptyNotice.innerHTML =
              '<div class="c-empty-fast-notice__inner">' +
                '<span class="c-empty-fast-notice__icon">📦</span>' +
                '<h3 class="c-empty-fast-notice__title">No designs match selected delivery options</h3>' +
                '<p class="c-empty-fast-notice__text">Try selecting other delivery options or reset delivery filters to see all available designs.</p>' +
                '<button type="button" class="btn btn--primary" data-turn-off-fast style="cursor:pointer;">Reset Delivery Filters</button>' +
              '</div>';
          }
          emptyNotice.style.display = 'block';

          var turnOffBtn = qs('[data-turn-off-fast]', emptyNotice);
          if (turnOffBtn) {
            turnOffBtn.onclick = function () {
              if (fastToggle) fastToggle.checked = false;
              if (normalToggle) normalToggle.checked = false;
              if (mtoToggle) mtoToggle.checked = false;
              onDeliveryChange(wrap);
            };
          }
        }
      }
    } else {
      if (emptyNotice) {
        emptyNotice.style.display = 'none';
      }
      if (anyActive && visibleCount > 0 && visibleCount < FILTERED_PRODUCT_BATCH_SIZE && hasMorePages) {
        loadMoreProducts(wrap || document, infEl);
      }
    }
  }

  /* --------------------------------------------------------------------------
     STATE SAVE / RESTORE — sessionStorage
  -------------------------------------------------------------------------- */
  var STATE_KEY  = 'fs_coll_grid';
  var SCROLL_KEY = 'fs_coll_scroll';
  var URL_KEY    = 'fs_coll_url';

  function canonicalUrl() {
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    return u.pathname + (u.search ? u.search : '');
  }

  function saveState(wrap) {
    try {
      // Filtered / partially-loaded grid ko save mat karo (restore pe galat dikhega)
      if (wrap._fsSkipped || isFilteredMode(wrap)) { clearState(); return; }
      var grid = qs('.product-grid', wrap);
      var infEl = qs('.infinity_scroll', wrap);
      if (!grid) return;
      sessionStorage.setItem(URL_KEY, canonicalUrl());
      sessionStorage.setItem(SCROLL_KEY, String(Math.round(window.scrollY)));
      sessionStorage.setItem(STATE_KEY, JSON.stringify({
        grid: grid.outerHTML,
        inf:  infEl ? infEl.outerHTML : null
      }));
    } catch (_) {}
  }

  function clearState() {
    try {
      sessionStorage.removeItem(STATE_KEY);
      sessionStorage.removeItem(SCROLL_KEY);
      sessionStorage.removeItem(URL_KEY);
    } catch (_) {}
  }

  /* --------------------------------------------------------------------------
     SCROLL RESTORE (time-based)
     Images load hone ke saath page ki height badhti hai, isliye target position
     ko ~3 sec tak baar-baar re-apply karte hain. User ne beech me khud
     scroll/touch kiya to turant ruk jata hai.
  -------------------------------------------------------------------------- */
  function restoreScrollPosition(target) {
    if (!target || target < 1) return;
    var start = Date.now();
    var stopped = false;
    var evs = ['wheel', 'touchstart', 'keydown', 'mousedown'];

    function stop() {
      stopped = true;
      evs.forEach(function (ev) { window.removeEventListener(ev, stop); });
    }
    evs.forEach(function (ev) { window.addEventListener(ev, stop, { passive: true }); });

    (function tick() {
      if (stopped) return;
      if (Math.abs(window.scrollY - target) > 2) {
        window.scrollTo({ top: target, behavior: 'instant' });
      }
      if (Date.now() - start < 3000) {
        requestAnimationFrame(tick);
      } else {
        stop();
      }
    })();
  }

  function restoreState(wrap) {
    try {
      // 1. URL must match the saved collection URL
      if (sessionStorage.getItem(URL_KEY) !== canonicalUrl()) { clearState(); return false; }

      var raw = sessionStorage.getItem(STATE_KEY);
      if (!raw) return false;

      // 2. Read scroll BEFORE clearing state
      var scrollTarget = parseInt(sessionStorage.getItem(SCROLL_KEY) || '0', 10);
      var saved = JSON.parse(raw);

      // 3. Clear stored data so a hard-reload starts fresh
      clearState();

      // 4. Restore product grid HTML
      var grid = qs('.product-grid', wrap);
      if (!grid || !saved.grid) return false;
      var tmp = document.createElement('div');
      tmp.innerHTML = saved.grid;
      var restoredGrid = tmp.firstElementChild;
      if (!restoredGrid) return false;
      grid.replaceWith(restoredGrid);

      // 5. Restore infinity_scroll element (next-page URL etc.)
      if (saved.inf) {
        var infEl = qs('.infinity_scroll', wrap);
        if (infEl) {
          tmp.innerHTML = saved.inf;
          var restoredInf = tmp.firstElementChild;
          if (restoredInf) infEl.replaceWith(restoredInf);
        }
      }

      // 6. Re-bind dynamic components on restored grid
      var newGrid = qs('.product-grid', wrap);
      if (window.Furniselan && window.Furniselan.init) window.Furniselan.init(newGrid || wrap);
      initInfiniteScroll(wrap);

      // 7. Scroll to saved position (time-based, images load hone tak re-apply)
      restoreScrollPosition(scrollTarget);

      // 8. Re-apply delivery badges after restore
      updateCardDeliveryBadges(wrap, getSavedPincode());
      wrap._fsUrl = curUrl();
      return true;
    } catch (_) { clearState(); return false; }
  }

  /* --------------------------------------------------------------------------
     SCROLL HELPER — controlled scroll to top of results (never random)
  -------------------------------------------------------------------------- */
  function scrollToResultsTop(wrap, smooth) {
    var top = wrap.getBoundingClientRect().top + window.pageYOffset - 80;
    if (window.pageYOffset > top) {
      window.scrollTo({ top: Math.max(0, top), behavior: (smooth && !reduceMotion) ? 'smooth' : 'auto' });
    }
  }

  /* --------------------------------------------------------------------------
     AJAX FULL-REPLACE RENDER (Filters, Sort, Pagination)
     opts.scroll = 'none'  → bilkul scroll mat karo (pincode update etc.)
  -------------------------------------------------------------------------- */
  function render(wrap, url, push, opts) {
    opts = opts || {};
    var sectionId = wrap.dataset.sectionId;
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    var prevFast = qs('[data-delivery-toggle="fast"], [data-fast-delivery-toggle]', wrap);
    var prevNormal = qs('[data-delivery-toggle="normal"], [data-normal-delivery-toggle]', wrap);
    var prevMto = qs('[data-delivery-toggle="mto"], [data-mto-delivery-toggle]', wrap);
    var wasFastActive = prevFast ? prevFast.checked : false;
    var wasNormalActive = prevNormal ? prevNormal.checked : false;
    var wasMtoActive = prevMto ? prevMto.checked : false;

    // DOM replace ho chuka hai ya nahi — agar ho chuka to error pe full reload NAHI karna
    var domReplaced = false;

    // Height lock: content replace hote waqt page chhota na ho (warna scroll upar clamp ho jata hai)
    wrap.style.minHeight = wrap.offsetHeight + 'px';
    wrap.classList.add('is-loading');
    closeMobileDrawer(wrap);
    isLoadingInfinite = false;
    destroyInfiniteScroll();
    clearState();
    wrap._fsSkipped = false;

    function unlockHeight() {
      requestAnimationFrame(function () { wrap.style.minHeight = ''; });
    }

    return fetch(fetchUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('collection fetch failed: HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-collection-results]', doc);
        if (!fresh) throw new Error('collection results missing from response');

        wrap.innerHTML = fresh.innerHTML;
        domReplaced = true;
        wrap.classList.remove('is-loading');
        if (push) history.pushState({ collection: true }, '', url);
        wrap._fsUrl = curUrl();

        // Store original count on fresh element
        var countEl = qs('#fcount', wrap);
        if (countEl) {
          countEl.dataset.originalCount = countEl.textContent.trim();
        }

        // Rebind freshly injected cards & plugins
        if (window.Furniselan && window.Furniselan.init) window.Furniselan.init(wrap);

        // Re-init filters UI (sliders, toggles, badges)
        initFiltersUI(wrap);

        // Restore delivery toggle states if previously active
        var newFast = qs('[data-delivery-toggle="fast"], [data-fast-delivery-toggle]', wrap);
        if (newFast && wasFastActive) newFast.checked = true;
        var newNormal = qs('[data-delivery-toggle="normal"], [data-normal-delivery-toggle]', wrap);
        if (newNormal && wasNormalActive) newNormal.checked = true;
        var newMto = qs('[data-delivery-toggle="mto"], [data-mto-delivery-toggle]', wrap);
        if (newMto && wasMtoActive) newMto.checked = true;

        // Re-init infinite scroll
        initInfiniteScroll(wrap);

        // Update card dynamic delivery text (which applies filters)
        updateCardDeliveryBadges(wrap, getSavedPincode());

        // Re-init product card sliders
        if (window.FS && window.FS.initProductCardSliders) window.FS.initProductCardSliders(wrap);

        closeMobileDrawer(wrap);
        unlockHeight();

        // Scroll sirf tab jab explicitly allowed ho
        if (opts.scroll !== 'none') {
          scrollToResultsTop(wrap, true);
        }

        // Background me agle pages cache karo
        schedulePrefetch(wrap);
      })
      .catch(function (err) {
        if (window.console) console.error('Collection update failed:', err);
        wrap.classList.remove('is-loading');
        wrap.style.minHeight = '';
        // Agar DOM badal chuka hai to koi JS error aaya hai (fetch fail nahi hua) —
        // full reload mat karo, warna page top pe chala jata hai.
        if (domReplaced) return;
        window.location.href = url;
      });
  }

  /* --------------------------------------------------------------------------
     INFINITE SCROLL
  -------------------------------------------------------------------------- */
  function destroyInfiniteScroll() {
    infiniteGen++;
    if (infiniteObserver) {
      infiniteObserver.disconnect();
      infiniteObserver = null;
    }
    isLoadingInfinite = false;
  }

  // True when any delivery or category filter is active (client-side filtering)
  function isFilteredMode(wrap) {
    return !!qs('[data-delivery-toggle="fast"]:checked, [data-delivery-toggle="normal"]:checked, [data-delivery-toggle="mto"]:checked, [data-category-checkbox]:checked', wrap);
  }

  function checkAndAutoLoad(wrap, infEl) {
    if (isLoadingInfinite) return;
    if (!infEl || !infEl.dataset.nextUrl || infEl.style.display === 'none') return;
    var rect = infEl.getBoundingClientRect();
    var screenHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top <= screenHeight + 1500) {
      loadMoreProducts(wrap, infEl);
    }
  }

  function initInfiniteScroll(wrap) {
    destroyInfiniteScroll();

    var infEl = qs('.infinity_scroll', wrap);
    if (!infEl) return;
    if (!infEl.dataset.nextUrl) return;

    var sentinel = qs('.inf-sentinel', infEl) || infEl;

    if ('IntersectionObserver' in window) {
      infiniteObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        loadMoreProducts(wrap, infEl);
      }, { rootMargin: '1500px 0px 1500px 0px', threshold: 0 });

      infiniteObserver.observe(sentinel);
    }

    if (!scrollCheckAttached) {
      scrollCheckAttached = true;
      var scrollRaf = null;
      window.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = null;
          var activeInf = qs('.infinity_scroll', document);
          var activeWrap = activeInf && activeInf.closest('[data-collection-results]');
          if (activeWrap && activeInf) {
            checkAndAutoLoad(activeWrap, activeInf);
          }
        });
      }, { passive: true });
    }

    setTimeout(function () {
      checkAndAutoLoad(wrap, infEl);
    }, 40);
  }

  /* ---------- page cache + prefetch ---------- */
  function buildPageUrl(baseUrl, p, sectionId) {
    var u = new URL(baseUrl.href);
    u.searchParams.set('page', p);
    u.searchParams.set('section_id', sectionId);
    return u.pathname + u.search;
  }

  // Promise cache: in-flight request bhi share hoti hai, dobara fetch nahi hota
  function fetchPageHtml(fetchUrl) {
    if (pageCache[fetchUrl]) return pageCache[fetchUrl];
    var pr = fetch(fetchUrl).then(function (r) {
      if (!r.ok) throw new Error('Infinite scroll fetch failed: HTTP ' + r.status);
      return r.text();
    }).catch(function (err) {
      delete pageCache[fetchUrl];
      throw err;
    });
    pageCache[fetchUrl] = pr;
    return pr;
  }

  function prefetchAhead(wrap, count) {
    var infEl = qs('.infinity_scroll', wrap);
    if (!infEl || !infEl.dataset.nextUrl) return;
    var base = new URL(infEl.dataset.nextUrl, window.location.origin);
    var start = parseInt(base.searchParams.get('page'), 10) || 2;
    var total = parseInt(infEl.dataset.totalPages, 10) || start;
    var sid = wrap.dataset.sectionId;
    var list = [];
    for (var p = start; p < start + count && p <= total; p++) list.push(buildPageUrl(base, p, sid));
    var i = 0;
    function next() {
      if (i >= list.length) return;
      var u = list[i++];
      fetchPageHtml(u).then(next, next);
    }
    next(); next();   // 2 parallel lanes — server pe load kam rakhne ke liye
  }

  function schedulePrefetch(wrap) {
    try {
      if (navigator.connection && navigator.connection.saveData) return;
    } catch (_) {}
    var run = function () { prefetchAhead(wrap, PREFETCH_PAGES); };
    var kick = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 3000 });
      else setTimeout(run, 1500);
    };
    if (document.readyState === 'complete') kick();
    else window.addEventListener('load', kick, { once: true });
  }

  /* ---------- helpers for off-DOM filtering ---------- */
  function getSelectedTypes(wrap) {
    var t = [];
    if (qs('[data-delivery-toggle="fast"]:checked', wrap)) t.push('fast');
    if (qs('[data-delivery-toggle="normal"]:checked', wrap)) t.push('normal');
    if (qs('[data-delivery-toggle="mto"]:checked', wrap)) t.push('mto');
    return t;
  }

  function cardMatchesDelivery(card, types) {
    if (!types.length) return true;
    var dType = getCardDeliveryType(card);
    if (types.indexOf(dType) === -1) return false;
    if (dType === 'fast') {
      if (card.dataset.available === 'false') return false;
      var priceEl = qs('.product-card__price', card);
      if (priceEl && priceEl.textContent.toLowerCase().indexOf('sold out') > -1) return false;
    }
    return true;
  }

  function cardMatchesCategory(card, vals) {
    if (!vals.length) return true;
    var cols = (card.dataset.productCollections || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
    var type = (card.dataset.productType || '').toLowerCase().trim();
    var handle = (card.dataset.productHandle || '').toLowerCase().trim();
    var tags = (card.dataset.productTags || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
    for (var i = 0; i < vals.length; i++) {
      var v = vals[i];
      if (cols.indexOf(v) > -1 || type === v || handle.indexOf(v) > -1 || tags.indexOf(v) > -1) return true;
    }
    return false;
  }

  function countVisibleCards(wrap) {
    return qsa('.product-card:not(.is-cat-hidden):not(.is-fast-hidden)', wrap).length;
  }

  /* filter change hone par: agar cards skip hue the to grid dobara build karo (cache se fast)
     keepScroll = true → scroll bilkul mat chhedo (pincode update etc.) */
  function onDeliveryChange(wrap, keepScroll) {
    if (wrap._fsSkipped) {
      wrap._fsSkipped = false;
      render(wrap, curUrl(), false, { scroll: keepScroll ? 'none' : 'top' });
      return;
    }
    applyFastDeliveryFilter(wrap);
    if (!keepScroll) scrollToResultsTop(wrap, false);
  }

  /* --------------------------------------------------------------------------
     LOAD MORE — progressive: har page aate hi process hokar dikh jata hai
  -------------------------------------------------------------------------- */
  function loadMoreProducts(wrap, infEl) {
    if (isLoadingInfinite) return;
    var nextUrl = infEl.dataset.nextUrl;
    if (!nextUrl) { destroyInfiniteScroll(); return; }

    isLoadingInfinite = true;
    var gen = infiniteGen;

    var gif = qs('.gif_image_inner', infEl);
    if (gif) gif.classList.remove('hidden');

    var sectionId = wrap.dataset.sectionId;
    var baseUrl = new URL(nextUrl, window.location.origin);
    var startPage = parseInt(baseUrl.searchParams.get('page'), 10) || ((parseInt(infEl.dataset.currentPage, 10) || 1) + 1);
    var totalPages = Math.max(parseInt(infEl.dataset.totalPages, 10) || startPage, startPage);
    var filtered = isFilteredMode(wrap);
    var parallel = filtered ? PARALLEL_PAGES : 1;

    var urls = [];
    for (var p = startPage; p < startPage + parallel && p <= totalPages; p++) {
      urls.push(buildPageUrl(baseUrl, p, sectionId));
    }

    // Saare fetch ek saath start (cache me already ho to instant)
    var promises = urls.map(fetchPageHtml);

    var currentGrid = qs('.product-grid', wrap);
    var types = filtered ? getSelectedTypes(wrap) : [];
    var catVals = filtered ? qsa('[data-category-checkbox]:checked', wrap).map(function (cb) {
      return (cb.value || '').toLowerCase().trim();
    }).filter(Boolean) : [];
    var pin = getSavedPincode();
    var lastDoc = null;
    var idx = 0;

    function processHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      lastDoc = doc;
      var freshGrid = qs('.product-grid', doc);
      if (!freshGrid || !currentGrid) return;

      // Badges + match check DOM ke BAHAR (fast, no layout cost)
      updateCardDeliveryBadges(freshGrid, pin, true);

      var batch = document.createDocumentFragment();
      var appended = 0;

      Array.prototype.slice.call(freshGrid.children).forEach(function (child) {
        if (child.classList && child.classList.contains('tcellrow')) {
          if (filtered || currentGrid.querySelector('.tcellrow')) return;
        }
        if (filtered && child.classList && child.classList.contains('product-card')) {
          if (!(cardMatchesDelivery(child, types) && cardMatchesCategory(child, catVals))) {
            wrap._fsSkipped = true;   // ye card grid me nahi aaya
            return;
          }
          // Sirf pehli 2 images eager (sab nahi — warna network choke hota hai)
          qsa('img[loading="lazy"]', child).slice(0, 2).forEach(function (img) { img.loading = 'eager'; });
        }
        batch.appendChild(child);
        appended++;
      });

      if (appended) {
        var yBefore = window.scrollY;
        currentGrid.appendChild(batch);
        if (window.Furniselan && window.Furniselan.init) window.Furniselan.init(currentGrid);
        // Append / re-init ke baad agar page achanak upar jump hua ho to wapas le aao
        requestAnimationFrame(function () {
          if (window.scrollY < yBefore - 300) {
            window.scrollTo({ top: yBefore, behavior: 'instant' });
          }
        });
      }

      if (filtered) {
        applyFastDeliveryFilter(wrap);          // count / empty-state update
      } else if (qs('[data-category-checkbox]', wrap)) {
        applyCategoryFilter(wrap);
      }
    }

    function step() {
      return promises[idx].then(function (html) {
        if (gen !== infiniteGen) return 'stale';
        processHtml(html);
        idx++;
        if (idx >= promises.length) return 'done';
        if (filtered && countVisibleCards(wrap) >= FILTERED_PRODUCT_BATCH_SIZE) return 'enough';
        // Main thread ko saans lene do (laptop lag fix)
        return new Promise(function (r) { setTimeout(r, 0); }).then(step);
      });
    }

    step().then(function (status) {
      if (status === 'stale' || gen !== infiniteGen) return;

      var freshPag = lastDoc && qs('.pagination', lastDoc);
      var currentPag = qs('.pagination', wrap);
      if (freshPag && currentPag) currentPag.innerHTML = freshPag.innerHTML;

      var freshInf = lastDoc && qs('.infinity_scroll', lastDoc);
      if (freshInf && freshInf.dataset.nextUrl) {
        infEl.dataset.nextUrl = freshInf.dataset.nextUrl;
        infEl.dataset.currentPage = freshInf.dataset.currentPage;
        infEl.dataset.totalPages = freshInf.dataset.totalPages;
        isLoadingInfinite = false;

        var sentinel = qs('.inf-sentinel', infEl) || infEl;
        if (infiniteObserver) {
          infiniteObserver.unobserve(sentinel);
          infiniteObserver.observe(sentinel);
        }

        var visible = filtered ? countVisibleCards(wrap) : 0;
        var rect = infEl.getBoundingClientRect();
        var screenHeight = window.innerHeight || document.documentElement.clientHeight;
        var needMore = rect.top <= screenHeight + 1500 || (filtered && visible < FILTERED_PRODUCT_BATCH_SIZE);

        if (needMore) {
          // Enough products dikh rahe hain to background loading thodi throttle karo
          var delay = (filtered && visible >= FILTERED_PRODUCT_BATCH_SIZE) ? 300 : 0;
          setTimeout(function () {
            if (gen === infiniteGen) loadMoreProducts(wrap, infEl);
          }, delay);
        } else {
          if (gif) gif.classList.add('hidden');
        }
      } else {
        if (gif) gif.classList.add('hidden');
        infEl.dataset.nextUrl = '';
        infEl.style.display = 'none';
        destroyInfiniteScroll();
        if (filtered) applyFastDeliveryFilter(wrap);
      }
    }).catch(function (err) {
      if (gen !== infiniteGen) return;
      if (window.console) console.error('Infinite scroll failed:', err);
      if (gif) gif.classList.add('hidden');
      isLoadingInfinite = false;
    });
  }

  /* --------------------------------------------------------------------------
     MOBILE DRAWER CONTROLS
  -------------------------------------------------------------------------- */
  function openMobileDrawer(wrap) {
    var sidebars = qsa('[data-collection-sidebar]', document);
    var backdrops = qsa('[data-drawer-backdrop]', document);
    sidebars.forEach(function (sb) { sb.classList.add('is-open'); });
    backdrops.forEach(function (bd) { bd.classList.add('is-open'); });
    document.body.classList.add('drawer-open-lock');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileDrawer(wrap) {
    var sidebars = qsa('[data-collection-sidebar]', document);
    var backdrops = qsa('[data-drawer-backdrop]', document);
    sidebars.forEach(function (sb) { sb.classList.remove('is-open'); });
    backdrops.forEach(function (bd) { bd.classList.remove('is-open'); });
    document.body.classList.remove('drawer-open-lock');
    document.body.style.overflow = '';
  }

  /* --------------------------------------------------------------------------
     FILTER FORM SERIALIZATION HELPER
  -------------------------------------------------------------------------- */
  function buildFilterSearchParams(form) {
    var formData = new FormData(form);
    var params = new URLSearchParams();

    formData.forEach(function (value, key) {
      var val = (value || '').toString().trim();
      if (val === '') return;

      if (key.indexOf('filter.v.price.gte') > -1) {
        var numGte = parseFloat(val);
        if (isNaN(numGte) || numGte <= 0) return;
      }
      if (key.indexOf('filter.v.price.lte') > -1) {
        var numLte = parseFloat(val);
        var rangeEl = form.querySelector('[data-price-range]');
        var maxLimit = rangeEl ? parseFloat(rangeEl.dataset.rangeMax || '0') : 0;
        if (isNaN(numLte) || (maxLimit > 0 && numLte >= maxLimit)) return;
      }

      params.append(key, val);
    });

    return params;
  }

  /* --------------------------------------------------------------------------
     SORT COLOR FILTER OPTIONS BY PRODUCT COUNT (DESCENDING)
  -------------------------------------------------------------------------- */
  function sortColorFilterOptions(wrap) {
    var groups = qsa('.c-filter-group', wrap);
    groups.forEach(function (group) {
      var titleEl = qs('.c-filter-group__title', group);
      var title = titleEl ? titleEl.textContent.toLowerCase() : '';
      var isColorGroup = title.indexOf('color') > -1 || title.indexOf('colour') > -1 || title.indexOf('finish') > -1;
      if (!isColorGroup && !qs('.c-filter-color-dot', group)) return;

      var list = qs('.c-filter-options', group);
      if (!list) return;

      var items = Array.prototype.slice.call(qsa('li.c-filter-option', list));
      if (items.length <= 1) return;

      items.sort(function (a, b) {
        var countA = 0, countB = 0;
        var rawCountA = a.dataset.optionCount;
        var rawCountB = b.dataset.optionCount;

        if (rawCountA !== undefined && rawCountA !== '') {
          countA = parseInt(rawCountA, 10) || 0;
        } else {
          var countElA = a.querySelector('.c-checkbox-count');
          if (countElA) {
            var mA = countElA.textContent.match(/\d+/);
            if (mA) countA = parseInt(mA[0], 10);
          }
        }

        if (rawCountB !== undefined && rawCountB !== '') {
          countB = parseInt(rawCountB, 10) || 0;
        } else {
          var countElB = b.querySelector('.c-checkbox-count');
          if (countElB) {
            var mB = countElB.textContent.match(/\d+/);
            if (mB) countB = parseInt(mB[0], 10);
          }
        }

        if (countB !== countA) return countB - countA;

        var checkedA = a.querySelector('input:checked') ? 1 : 0;
        var checkedB = b.querySelector('input:checked') ? 1 : 0;
        if (checkedB !== checkedA) return checkedB - checkedA;

        var textA = (a.querySelector('.c-checkbox-text') || {}).textContent || '';
        var textB = (b.querySelector('.c-checkbox-text') || {}).textContent || '';
        return textA.localeCompare(textB);
      });

      var isExpanded = list.classList.contains('is-expanded');
      items.forEach(function (item, idx) {
        if (idx >= 10 && !isExpanded) {
          item.classList.add('is-hidden-option');
        } else {
          item.classList.remove('is-hidden-option');
        }
        list.appendChild(item);
      });

      var showMoreBtn = group.querySelector('[data-show-more-btn]');
      if (showMoreBtn) {
        var showMoreText = showMoreBtn.querySelector('.c-show-more-text');
        if (showMoreText && items.length > 10) {
          showMoreText.textContent = '+ Show ' + (items.length - 10) + ' More';
        }
      }
    });
  }

  /* --------------------------------------------------------------------------
     CATEGORY FILTER (Supports multiple selections & client-side instant filtering)
  -------------------------------------------------------------------------- */
  function applyCategoryFilter(wrap) {
    var catCheckboxes = qsa('[data-category-checkbox]', wrap);
    if (!catCheckboxes.length) return;

    var checkedCbs = qsa('[data-category-checkbox]:checked', wrap);
    var selectedVals = checkedCbs.map(function (cb) {
      return (cb.value || '').toLowerCase().trim();
    }).filter(Boolean);

    // Update Category group badge
    var catGroup = qs('[data-category-filter-group]', wrap);
    if (catGroup) {
      var badge = qs('[data-category-badge]', catGroup);
      if (badge) {
        if (selectedVals.length > 0) {
          badge.textContent = selectedVals.length;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    }

    // Filter product cards
    var cards = qsa('.product-card', wrap);
    cards.forEach(function (card) {
      if (selectedVals.length === 0) {
        card.classList.remove('is-cat-hidden');
        return;
      }

      var cardCols = (card.dataset.productCollections || '').toLowerCase().split(',').map(function (s) { return s.trim(); });
      var cardType = (card.dataset.productType || '').toLowerCase().trim();
      var cardHandle = (card.dataset.productHandle || '').toLowerCase().trim();
      var cardTags = (card.dataset.productTags || '').toLowerCase().split(',').map(function (s) { return s.trim(); });

      var matched = false;
      for (var i = 0; i < selectedVals.length; i++) {
        var val = selectedVals[i];
        if (cardCols.indexOf(val) > -1 || cardType === val || cardHandle.indexOf(val) > -1 || cardTags.indexOf(val) > -1) {
          matched = true;
          break;
        }
      }

      if (matched) {
        card.classList.remove('is-cat-hidden');
      } else {
        card.classList.add('is-cat-hidden');
      }
    });

    // Update active filter pills container
    var activeContainer = qs('.c-active-filters', wrap);
    qsa('[data-category-pill]', activeContainer || wrap).forEach(function (pill) { pill.remove(); });

    if (selectedVals.length > 0) {
      if (!activeContainer) {
        var form = qs('[data-filter-form]', wrap);
        var filtersList = qs('.c-filters__list', wrap);
        if (form && filtersList) {
          activeContainer = document.createElement('div');
          activeContainer.className = 'c-active-filters';
          form.insertBefore(activeContainer, filtersList);
        }
      }

      if (activeContainer) {
        checkedCbs.forEach(function (cb) {
          var labelEl = cb.closest('.c-checkbox-label');
          var nameText = labelEl ? (labelEl.querySelector('.c-checkbox-text') || {}).textContent : cb.value;
          var pill = document.createElement('a');
          pill.className = 'c-active-pill';
          pill.href = '#';
          pill.dataset.categoryPill = cb.value;
          pill.innerHTML = '<span>' + (nameText || cb.value) + '</span><span class="c-active-pill__x">×</span>';
          pill.addEventListener('click', function (e) {
            e.preventDefault();
            cb.checked = false;
            applyCategoryFilter(wrap);
          });
          activeContainer.appendChild(pill);
        });
      }
    }

    // Re-apply delivery filter (which updates count display with both filters applied)
    applyFastDeliveryFilter(wrap);

    // Update URL query parameter without full reload
    try {
      var currentUrl = new URL(window.location.href);
      if (selectedVals.length > 0) {
        currentUrl.searchParams.set('category', selectedVals.join(','));
      } else {
        currentUrl.searchParams.delete('category');
      }
      history.replaceState({ collection: true }, '', currentUrl.toString());
      wrap._fsUrl = curUrl();
    } catch (e) {}
  }

  function initCategoryFilter(wrap) {
    var catLinks = qsa('[data-category-link]', wrap);
    if (!catLinks.length) return;

    catLinks.forEach(function (link) {
      if (link._hasCatLinkListener) return;
      link._hasCatLinkListener = true;
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        if (window.innerWidth <= 991) {
          closeMobileDrawer(wrap);
        }
        if (link.classList.contains('is-active') && window.location.pathname === href) {
          return;
        }
        render(wrap, href, true);
      });
    });
  }

  /* --------------------------------------------------------------------------
     FILTERS UI (Price Slider, Fast Delivery Toggle, Pin Events)
  -------------------------------------------------------------------------- */
  function initFiltersUI(wrap) {
    var form = qs('[data-filter-form]', wrap);
    var pin = getSavedPincode();

    // 1. Fast Delivery Status UI
    var pinTextEl = qs('[data-fast-pin-text]', wrap);
    var toggle = qs('[data-fast-delivery-toggle]', wrap);

    if (pin && pin.length === 6) {
      var hit = checkPincodeStatus(pin);
      if (pinTextEl) {
        if (hit && hit.isFast) {
          pinTextEl.innerHTML = 'Delivering to <strong>' + pin + '</strong> (1-2 Days Express)';
        } else {
          pinTextEl.innerHTML = 'Delivering to <strong>' + pin + '</strong>';
        }
      }
    } else {
      if (pinTextEl) pinTextEl.textContent = 'Enter Pincode to view express items';
    }

    function afterToggle() {
      if (window.innerWidth <= 991) {
        closeMobileDrawer(wrap);
      }
      var infEl = qs('.infinity_scroll', wrap);
      if (infEl) {
        checkAndAutoLoad(wrap, infEl);
      }
    }

    // Toggle Fast Delivery Handler
    if (toggle && !toggle._hasFastDeliveryListener) {
      toggle._hasFastDeliveryListener = true;
      toggle.addEventListener('change', function () {
        var currentPin = getSavedPincode();
        if (toggle.checked && (!currentPin || currentPin.length !== 6)) {
          // Open pincode modal
          toggle.checked = false;
          var pinModal = qs('[data-pin-modal]');
          if (pinModal && FS.Overlay && typeof FS.Overlay.show === 'function') {
            FS.Overlay.show(pinModal);
          } else {
            var openBtn = qs('[data-pin-open]');
            if (openBtn) openBtn.click();
          }
          return;
        }
        onDeliveryChange(wrap);
        afterToggle();
      });
    }

    // Toggle Normal Delivery Handler
    var normalToggle = qs('[data-delivery-toggle="normal"], [data-normal-delivery-toggle]', wrap);
    if (normalToggle && !normalToggle._hasNormalDeliveryListener) {
      normalToggle._hasNormalDeliveryListener = true;
      normalToggle.addEventListener('change', function () {
        onDeliveryChange(wrap);
        afterToggle();
      });
    }

    // Toggle Made to Order Handler
    var mtoToggle = qs('[data-delivery-toggle="mto"], [data-mto-delivery-toggle]', wrap);
    if (mtoToggle && !mtoToggle._hasMtoDeliveryListener) {
      mtoToggle._hasMtoDeliveryListener = true;
      mtoToggle.addEventListener('change', function () {
        onDeliveryChange(wrap);
        afterToggle();
      });
    }

    // 2. Price Range Double Slider
    qsa('[data-price-range]', wrap).forEach(function (rangeEl) {
      // Duplicate listeners rokne ke liye guard (pincode update pe initFiltersUI dobara chalta hai)
      if (!once(rangeEl, 'PriceRange')) return;

      var minInput = qs('[data-price-min-input]', rangeEl);
      var maxInput = qs('[data-price-max-input]', rangeEl);
      var sliderMin = qs('[data-price-slider-min]', rangeEl);
      var sliderMax = qs('[data-price-slider-max]', rangeEl);
      var bar = qs('[data-price-slider-bar]', rangeEl);
      var maxLimit = parseFloat(rangeEl.dataset.rangeMax || '100000');

      function syncTrack() {
        if (!bar || !sliderMin || !sliderMax) return;
        var valMin = parseFloat(sliderMin.value || '0');
        var valMax = parseFloat(sliderMax.value || maxLimit);
        var pctMin = Math.min(100, Math.max(0, (valMin / maxLimit) * 100));
        var pctMax = Math.min(100, Math.max(0, (valMax / maxLimit) * 100));
        bar.style.left = pctMin + '%';
        bar.style.right = (100 - pctMax) + '%';
      }

      if (sliderMin && sliderMax) {
        sliderMin.addEventListener('input', function () {
          var valMin = parseFloat(sliderMin.value);
          var valMax = parseFloat(sliderMax.value);
          if (valMin > valMax) { sliderMin.value = valMax; valMin = valMax; }
          if (minInput) minInput.value = Math.round(valMin);
          syncTrack();
        });

        sliderMax.addEventListener('input', function () {
          var valMin = parseFloat(sliderMin.value);
          var valMax = parseFloat(sliderMax.value);
          if (valMax < valMin) { sliderMax.value = valMin; valMax = valMin; }
          if (maxInput) maxInput.value = Math.round(valMax);
          syncTrack();
        });

        var debounceTimer = null;
        function triggerFilterChange() {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            if (form) {
              var params = buildFilterSearchParams(form);
              var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
              render(wrap, newUrl, true);
            }
          }, 450);
        }

        sliderMin.addEventListener('change', triggerFilterChange);
        sliderMax.addEventListener('change', triggerFilterChange);
        if (minInput) {
          minInput.addEventListener('change', function () {
            var v = parseFloat(minInput.value || '0');
            sliderMin.value = v;
            syncTrack();
            triggerFilterChange();
          });
        }
        if (maxInput) {
          maxInput.addEventListener('change', function () {
            var v = parseFloat(maxInput.value || maxLimit);
            sliderMax.value = v;
            syncTrack();
            triggerFilterChange();
          });
        }

        syncTrack();
      }
    });

    // 3. Update active filter count badge on mobile trigger button
    var activePills = qsa('.c-active-pill', wrap);
    var filterBadge = qs('[data-filter-count-badge]', wrap);
    if (filterBadge) {
      if (activePills.length > 0) {
        filterBadge.textContent = activePills.length;
        filterBadge.hidden = false;
      } else {
        filterBadge.hidden = true;
      }
    }

    // 4. Sort Color Filter options by count (descending)
    sortColorFilterOptions(wrap);

    // 5. Category Filter initialization
    initCategoryFilter(wrap);
  }

  /* --------------------------------------------------------------------------
     INIT (Bound once per [data-collection-results])
  -------------------------------------------------------------------------- */
  function initCollection(ctx) {
    qsa('[data-collection-results]', ctx).forEach(function (wrap) {
      if (!once(wrap, 'Collection')) return;

      wrap._fsUrl = curUrl();

      // ── Back-navigation restore OR fresh page load ──
      // NOTE: fresh load pe ab koi scrollTo(0) nahi hai. Browser khud top se start karta hai,
      // aur pehle wala "scrollTo(0)" late-loaded script pe user ko upar kheench leta tha.
      var wasRestored = restoreState(wrap);

      if (!wasRestored) {
        initInfiniteScroll(wrap);
      }

      var countEl = qs('#fcount', wrap);
      if (countEl && !countEl.dataset.originalCount) {
        countEl.dataset.originalCount = countEl.textContent.trim();
      }

      initFiltersUI(wrap);
      updateCardDeliveryBadges(wrap, getSavedPincode());

      // Background me agle pages warm-cache karo (filter ON karte hi instant results)
      schedulePrefetch(wrap);

      // ── Save state before navigating to a product ──
      document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) === '#') return;
        if (href.indexOf('/products/') === -1) return;
        saveState(wrap);
      }, { capture: true });

      // ── Sort change → AJAX replace ──
      wrap.addEventListener('change', function (e) {
        var select = e.target.closest('[data-sort-select]');
        if (!select) return;
        var form = qs('[data-filter-form]', wrap);
        if (form) {
          var sortInput = qs('input[name="sort_by"]', form);
          if (sortInput) sortInput.value = select.value;
          var params = buildFilterSearchParams(form);
          var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
          render(wrap, newUrl, true);
        } else {
          var u = new URL(window.location.href);
          u.searchParams.set('sort_by', select.value);
          u.searchParams.delete('page');
          render(wrap, u.toString(), true);
        }
      });

      // ── Native Filter Checkbox Change ──
      wrap.addEventListener('change', function (e) {
        var cb = e.target.closest('[data-filter-checkbox]');
        if (!cb) return;
        if (window.innerWidth <= 991) {
          closeMobileDrawer(wrap);
        }
        var form = qs('[data-filter-form]', wrap);
        if (form) {
          var params = buildFilterSearchParams(form);
          var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
          render(wrap, newUrl, true);
        }
      });

      // ── Show More / Show Less Button ──
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-show-more-btn]');
        if (!btn) return;
        e.preventDefault();
        var list = btn.previousElementSibling;
        if (!list || !list.matches('[data-filter-list]')) {
          var groupContent = btn.closest('.c-filter-group__content');
          list = groupContent && groupContent.querySelector('[data-filter-list]');
        }
        if (list) {
          var isExpanded = list.classList.toggle('is-expanded');
          btn.classList.toggle('is-active', isExpanded);
          btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }
      });

      // ── Clear all and Pill Clicks ──
      wrap.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-filter-pill], [data-filter-clear-all]');
        if (pill) {
          e.preventDefault();
          if (window.innerWidth <= 991) {
            closeMobileDrawer(wrap);
          }
          if (pill.matches('[data-filter-clear-all]')) {
            qsa('[data-category-checkbox]', wrap).forEach(function (c) { c.checked = false; });
            applyCategoryFilter(wrap);
          }
          var href = pill.getAttribute('href') || (window.location.pathname + '?sort_by=' + (qs('#fsort', wrap) ? qs('#fsort', wrap).value : 'manual'));
          render(wrap, href, true);
          return;
        }

        // Standard pagination links
        var link = e.target.closest('.pagination a[href]');
        if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        render(wrap, link.href, true);
      });

      // ── Mobile Drawer Open / Close ──
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-open]')) {
          openMobileDrawer(wrap);
          return;
        }
        if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-backdrop]')) {
          closeMobileDrawer(wrap);
          return;
        }
      });

      // ── Listen for pincode updates from global theme popup ──
      // yahan scroll kabhi nahi hona chahiye
      window.addEventListener('pincode:updated', function (e) {
        var newPin = (e.detail && e.detail.pincode) || getSavedPincode();
        initFiltersUI(wrap);
        if (wrap._fsSkipped && getSelectedTypes(wrap).length) {
          onDeliveryChange(wrap, true);
        } else {
          updateCardDeliveryBadges(wrap, newPin);
        }
      });

      // ── Browser back / forward ──
      // Sirf tab react karte hain jab collection URL sach me badla ho (reload kabhi nahi).
      window.addEventListener('popstate', function () {
        if (!document.contains(wrap)) return;
        var now = curUrl();
        if (now === wrap._fsUrl) return;          // URL same → kuch mat karo

        var restored = restoreState(wrap);
        if (restored) { wrap._fsUrl = now; return; }

        // Saved state nahi: reload ki jagah AJAX se sahi URL ka grid laao
        render(wrap, now, false, { scroll: 'none' });
      });

      // ── iOS Safari / bfcache ──
      // bfcache me page apni scroll position ke saath intact aata hai — scroll mat chhedo.
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        if (!document.contains(wrap)) return;
        clearState();   // DOM already intact hai, stale saved state hata do
      });
    });
  }

  window.FS = window.FS || {};
  window.FS.initCollection = initCollection;
  window.FS.applyFastDeliveryFilter = applyFastDeliveryFilter;

  // Auto-init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollection(document);
    });
  } else {
    initCollection(document);
  }
})();